import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['salesPrivateNote']

  connect() {
    this.adjustSalesPrivateNoteHeight()
  }

  adjustSalesPrivateNoteHeight() {
    const value = window.innerHeight - 150;
    this.salesPrivateNoteTarget.style.maxHeight = `${value}px`
  }
}
